import { Moon, Sun } from "lucide-react";

const MapControls = ({ darkMode, toggleDark }) => (
    <div className="map-controls">
        <button onClick={toggleDark} title="Basculer mode clair/sombre">
            {darkMode ? <Sun size={14} /> : <Moon size={14} />}
        </button>
    </div>
);

export default MapControls;
